import type { PresenceStatus } from '@/types/presence'

const MIN = 60
const HOUR = 60 * MIN
const DAY = 24 * HOUR

/**
 * Rótulo relativo "desde quando no estado" a partir de last_seen_at (epoch SEGUNDOS).
 * null/undefined → null (nunca conectou; chamador mostra estado seco). Clampa skew futuro em 0.
 */
export function relativeSince(lastSeenAtSec: number | null | undefined, nowMs: number): string | null {
  if (lastSeenAtSec == null) return null
  const diff = Math.max(0, Math.floor(nowMs / 1000) - lastSeenAtSec)
  if (diff < MIN) return 'agora'
  if (diff < HOUR) return `há ${Math.floor(diff / MIN)}min`
  if (diff < DAY) return `há ${Math.floor(diff / HOUR)}h`
  return `há ${Math.floor(diff / DAY)}d`
}

const STATUS_LABELS: Record<PresenceStatus, string> = {
  online: 'Online',
  afk: 'Ausente',
  offline: 'Offline',
}

export function presenceStatusLabel(status: PresenceStatus): string {
  return STATUS_LABELS[status]
}

/** Normaliza o estado do user — fallback 'offline'. `presence_status` é `?:` no
 *  `AdminUser` legado e `| null` no snapshot de presença; os dois caem aqui. */
export function presenceOf(u: { presence_status?: PresenceStatus | null }): PresenceStatus {
  return u.presence_status ?? 'offline'
}

/** "Online há 2h" · "Offline" (sem tempo quando last_seen_at é null). */
export function presenceFullLabel(
  status: PresenceStatus,
  lastSeenAtSec: number | null | undefined,
  nowMs: number,
): string {
  const rel = relativeSince(lastSeenAtSec, nowMs)
  return rel ? `${presenceStatusLabel(status)} ${rel}` : presenceStatusLabel(status)
}
